import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { Formik } from 'formik';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { PrimaryButton } from '../../../components/Buttons';
import appConfig from '../../../../app-config';
import { connect } from 'react-redux';
import { showSelectPaymentMethodForm } from '../paymentMethodsActions';

const MainDiv = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 5%;
`;

const FormGrid = styled.div`
  display: grid;
  grid-gap: 15px;
`;

function PaymentMethodDetails({
  open,
  details,
  paymentMethod,
  initiateDeletePaymentMethod,
  setDefaultPaymentMethod,
  is_preferred,
  handleClose,
  showPaymentMethodSelectionForm,
  showSelectPaymentMethodForm,
}) {
  const handleInitiateDeletePaymentMethod = (event) => {
    // event.stopPropagation();
    initiateDeletePaymentMethod(paymentMethod.id);
  };
  const handleSetDefaultPaymentMethod = (paymentMethodid) => {
    setDefaultPaymentMethod(paymentMethodid);
    handleClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose(false);
      }}
      maxWidth='xs'
      fullWidth={true}
    >
      <MainDiv>
        <DialogTitle
          id='PaymentMethodPreview-Title'
          style={{ margin: 0, padding: 0, marginBottom: '5%' }}
        >
          {details?.card_type
            ? details.card_type.charAt(0).toUpperCase() +
              details.card_type.slice(1)
            : null}
        </DialogTitle>
        <IconButton
          id='PaymentMethodPreview-Close'
          aria-label='close'
          onClick={(e) => {
            e.stopPropagation();
            handleClose(false);
          }}
          style={{
            position: 'absolute',
            right: '1%',
            top: '3%',
          }}
        >
          <span className='fa fa-times' />
        </IconButton>
        <Formik
          initialValues={{
            lastFour: `**** **** **** ${details?.last_four}`,
            expiryDate: moment(details?.expiry_date).format('MM/YY'),
          }}
        >
          {({ initialValues }) => (
            <FormGrid>
              <TextField
                id='PaymentMethodPreview-CardNumber'
                label='Card Number'
                name='lastFour'
                value={initialValues.lastFour}
                disabled
              />
              <TextField
                id='PaymentMethodPreview-ExpiryDate'
                label='Expiry Date'
                name='expiryDate'
                value={initialValues.expiryDate}
                disabled
              />
              {(!appConfig.isOnlyOneGiftCard ||
                paymentMethod.type !== 'gift_card') && (
                <div style={{ margin: 0, padding: 0 }}>
                  <Button
                    id='PaymentMethodPreview-RemoveCard'
                    size='small'
                    startIcon={<i className='fal fa-trash-alt' />}
                    onClick={handleInitiateDeletePaymentMethod}
                  >
                    Remove Card
                  </Button>
                </div>
              )}
              <PrimaryButton
                id='PaymentMethodPreview-DefaultPaymentMethod'
                onClick={(e) => {
                  e.stopPropagation();
                  handleSetDefaultPaymentMethod(paymentMethod.id);
                  handleClose(false);
                  showPaymentMethodSelectionForm(false);
                  showSelectPaymentMethodForm(false);
                }}
                disabled={is_preferred}
              >
                {is_preferred
                  ? 'Default Payment Method'
                  : 'Make Default Payment Method'}
              </PrimaryButton>
            </FormGrid>
          )}
        </Formik>
      </MainDiv>
    </Dialog>
  );
}
export default connect(null, {
  showSelectPaymentMethodForm,
})(PaymentMethodDetails);
